module.exports = __webpack_public_path__ + "static/media/188-virgin-islands.2bbab769.svg";